/* Mobile drawer: page → section sub-items with anchor scroll.
   Data source: <script id="mobile-drawer-data"> rendered by mobile-drawer-pages.liquid. */
(function () {
  'use strict';

  // Take ownership of scroll position before the browser tries to auto-scroll
  // to a hash that won't resolve (Shopify mangles section IDs).
  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (_) {}
  }

  var SCROLL_OFFSET_FALLBACK = 80;
  var HASH_KEY = 'kolde:pending-anchor';

  function getHeaderOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(v);
    return isNaN(n) || n <= 0 ? SCROLL_OFFSET_FALLBACK : n;
  }

  function readRegistry() {
    var el = document.getElementById('mobile-drawer-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function normalizePath(p) {
    if (!p) return '/';
    // Strip trailing slash except for root
    return p.length > 1 ? p.replace(/\/+$/, '') : '/';
  }

  function pageMatchesCurrent(pageUrl, currentPath) {
    return normalizePath(pageUrl) === normalizePath(currentPath);
  }

  function svgChevron() {
    return '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function closeDrawer() {
    var drawer = document.getElementById('mobile-menu-drawer');
    if (!drawer) return;
    // Apollo's drawer custom element dispatches/responds to 'close'.
    if (typeof drawer.close === 'function') {
      drawer.close();
      return;
    }
    var closeBtn = drawer.querySelector('[data-action="close"]');
    if (closeBtn) closeBtn.click();
  }

  // Builds a fresh map of { cleanSectionKey -> shopify-section element } by
  // scanning the live DOM. This is the source of truth: works regardless of
  // whether Shopify prefixes IDs with a template hash or not.
  function buildSectionMap() {
    var map = {};
    var nodes = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].id;
      var rest = id.replace(/^shopify-section-/, '');
      var key = rest.indexOf('__') >= 0 ? rest.split('__').pop() : rest;
      map[key] = nodes[i];
    }
    return map;
  }

  function resolveAnchorElement(anchor) {
    // Exact id match (e.g. the user passed a real DOM id).
    var el = document.getElementById(anchor);
    if (el) return el;

    // Strip our registry's "shopify-section-" prefix and look up by clean key.
    var key = anchor.replace(/^shopify-section-/, '');
    var map = buildSectionMap();
    if (map[key]) return map[key];

    // Last-resort suffix/substring fallbacks.
    el = document.querySelector('[id$="__' + key + '"]') ||
         document.querySelector('[id$="-' + key + '"]') ||
         document.getElementById('shopify-section-' + key) ||
         document.querySelector('[id$="' + key + '"]') ||
         document.querySelector('[id*="' + key + '"]');
    return el || null;
  }

  function smoothScrollToId(anchor) {
    var el = resolveAnchorElement(anchor);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    return true;
  }

  function bodyScrollLocked() {
    var s = getComputedStyle(document.body);
    return s.overflow === 'hidden' || s.position === 'fixed';
  }

  function scrollWhenReady(anchor, attempt) {
    attempt = attempt || 0;
    if (attempt > 25) return;
    if (bodyScrollLocked()) {
      setTimeout(function () { scrollWhenReady(anchor, attempt + 1); }, 60);
      return;
    }
    if (!smoothScrollToId(anchor)) {
      setTimeout(function () { scrollWhenReady(anchor, attempt + 1); }, 60);
    }
  }

  function handleLeafClick(e, anchor, pageUrl) {
    var sameOrigin = pageMatchesCurrent(pageUrl, location.pathname);
    e.preventDefault();
    if (sameOrigin) {
      closeDrawer();
      scrollWhenReady(anchor);
      history.replaceState(null, '', '#' + anchor);
    } else {
      // Cross-page: stash the anchor for the destination page; navigate WITHOUT the
      // hash so the browser doesn't try to auto-scroll to an id that doesn't exist
      // (Shopify mangles section IDs with a template hash).
      try { sessionStorage.setItem(HASH_KEY, anchor); } catch (_) {}
      window.location.assign(pageUrl);
    }
  }

  function closeAllPages(mount, except) {
    mount.querySelectorAll('.mn-page.is-open').forEach(function (other) {
      if (other === except) return;
      other.classList.remove('is-open');
      var chev = other.querySelector('.mn-page__chev');
      if (chev) chev.setAttribute('aria-expanded', 'false');
    });
  }

  function render(registry, mount) {
    var currentPath = mount.getAttribute('data-current-url') || location.pathname;
    mount.innerHTML = '';
    registry.pages.forEach(function (page) {
      var li = document.createElement('li');
      li.className = 'mn-page';
      var isCurrent = pageMatchesCurrent(page.url, currentPath);
      if (isCurrent) li.classList.add('is-open');

      var hasSections = page.sections && page.sections.length > 0;

      // Page header: clickable label (navigates to page) + optional chevron (toggles sub-items).
      var head = document.createElement('div');
      head.className = 'mn-page__head';

      var link = document.createElement('a');
      link.className = 'mn-page__title';
      link.textContent = page.label;
      link.href = page.url;
      if (isCurrent) link.setAttribute('aria-current', 'page');
      head.appendChild(link);

      if (hasSections) {
        var chev = document.createElement('button');
        chev.type = 'button';
        chev.className = 'mn-page__chev';
        chev.setAttribute('aria-label', 'Toggle ' + page.label + ' sub-items');
        chev.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
        chev.innerHTML = svgChevron();
        chev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !li.classList.contains('is-open');
          // Single-open accordion: close everything else first.
          closeAllPages(mount, willOpen ? li : null);
          li.classList.toggle('is-open', willOpen);
          chev.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        head.appendChild(chev);
      }

      li.appendChild(head);

      if (hasSections) {
        var sub = document.createElement('ul');
        sub.className = 'mn-sublist list--unstyled';

        page.sections.forEach(function (section) {
          var item = document.createElement('li');
          item.className = 'mn-sub__item';
          var a = document.createElement('a');
          a.className = 'mn-sub__link';
          a.textContent = section.label;

          if (section.anchor) {
            // Anchor sub-item: scroll within the (parent) page.
            a.href = page.url + '#' + section.anchor;
            a.addEventListener('click', function (e) {
              handleLeafClick(e, section.anchor, page.url);
            });
          } else if (section.url) {
            // Plain navigation sub-item (e.g. cross-page link without anchor).
            a.href = section.url;
          } else {
            a.href = page.url;
          }
          item.appendChild(a);
          sub.appendChild(item);
        });
        li.appendChild(sub);
      }

      mount.appendChild(li);
    });
  }

  // Tracks the anchor we're currently trying to land on. Set once per page load.
  var pendingAnchor = null;
  var landed = false;

  function scrollToElement(el) {
    var top = el.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    if (top < 0) top = 0;
    // Use both methods for maximum compatibility — scrollIntoView handles edge
    // cases where the viewport coordinates are stale, scrollTo handles header offset.
    try { el.scrollIntoView({ block: 'start', behavior: 'auto' }); } catch (_) {}
    window.scrollTo(0, top);
  }

  function resolveAndScroll() {
    if (!pendingAnchor || landed) return false;
    var el = resolveAnchorElement(pendingAnchor);
    if (!el) return false;
    scrollToElement(el);
    return true;
  }

  function correctScroll() {
    if (!pendingAnchor) return;
    var el = resolveAnchorElement(pendingAnchor);
    if (!el) return;
    var desired = el.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    if (desired < 0) desired = 0;
    if (Math.abs(desired - window.scrollY) > 4) {
      window.scrollTo(0, desired);
    }
  }

  function handlePendingHashOnLoad() {
    if (pendingAnchor && landed) return; // already done

    if (!pendingAnchor) {
      var anchor = null;
      try { anchor = sessionStorage.getItem(HASH_KEY); } catch (_) {}
      if (anchor) {
        try { sessionStorage.removeItem(HASH_KEY); } catch (_) {}
      } else if (location.hash) {
        anchor = location.hash.replace(/^#/, '');
      }
      if (!anchor) return;
      pendingAnchor = anchor;
    }

    // Aggressive retry: every 100 ms for up to 5 s until the element is found.
    var attempts = 0;
    var tryScroll = function () {
      if (resolveAndScroll()) {
        landed = true;
        // Layout-shift correction window: keep correcting for the next 3 s.
        var correctionDeadline = Date.now() + 3000;
        var correctionTick = function () {
          if (Date.now() > correctionDeadline) return;
          correctScroll();
          setTimeout(correctionTick, 200);
        };
        setTimeout(correctionTick, 200);
        return;
      }
      if (++attempts < 50) setTimeout(tryScroll, 100);
    };
    tryScroll();
  }

  function init() {
    var mount = document.getElementById('mobile-drawer-tree');
    if (!mount) return;
    var registry = readRegistry();
    if (!registry || !Array.isArray(registry.pages)) return;
    render(registry, mount);
  }

  function boot() {
    init();
    handlePendingHashOnLoad();
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
  // Also re-attempt after full load — covers late lazy-loaded sections that
  // weren't laid out yet at DOMContentLoaded.
  window.addEventListener('load', handlePendingHashOnLoad);
})();
